module.exports = __webpack_public_path__ + "img/galeria-plantas-vasculares1.686b8850.jpg";